import { FC, useState, ChangeEvent } from 'react';
import { v4 as uuid } from 'uuid';
// Redux
import { useAppDispatch, useAppSelector } from 'hooks/useStore';
import { setQuestionStart } from 'store/player/playerSlice';
import { selectQuestion } from 'store/quiz/quizSelectors';
import IQuestion from 'models/Question';
// Component
import { Button } from 'components/Buttons';
import { Input } from 'components/Controls';
// i18next
import { useTranslation } from 'react-i18next';

type Props = {
  onSubmit: (answer:{ ref:string, title:string, correct?:boolean }) => void;
  disabled?: boolean;
};

const ScoreAnswers:FC<Props> = ({ onSubmit, disabled = false }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const question:IQuestion = useAppSelector(selectQuestion);

  const [ clicked, setClicked ] = useState<boolean>(false);

  const [ firstScore, setFirstScore ] = useState<string>('');
  const [ secondScore, setSecondScore ] = useState<string>('');

  const handleTitle = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    if (name === 'question-game-score-1') {
      setFirstScore(`${value}`);
    } else {
      setSecondScore(`${value}`);
    }
  }

  const handleSubmit = () => {
    if(clicked) return;
    onSubmit({
      ref: uuid(),
      title: `${firstScore}-${secondScore}`,
    });
    dispatch(setQuestionStart(false));
    setClicked(true);
  }

  return (
    <div>
      <div className="flex gap-4">
        <Input
          name="question-game-score-1" id="question-game-score-1"
          placeholder={question.scorePlaceholder1 || t('labels.numberedScore', { number: 1 })}
          value={firstScore}
          onChange={handleTitle}
          disabled={disabled || clicked}
          type="number"
        />
        <Input
          name="question-game-score-2" id="question-game-score-2"
          placeholder={question.scorePlaceholder2 || t('labels.numberedScore', { number: 2 })}
          value={secondScore}
          onChange={handleTitle}
          disabled={disabled || clicked}
          type="number"
        />
      </div>
      <Button
        className="w-full text-xl uppercase primary-button"
        onClick={handleSubmit}
        disabled={!firstScore.trim() || !secondScore.trim() || clicked}
      >
        {t('buttons.next')}
      </Button>
    </div>
  )
}

export default ScoreAnswers;
